import React from 'react';
import { Stack } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { formatCurrency } from '@/utils/constants';
import { HeaderDetail } from './HeaderDetail';

export const ClientIncome = () => {
	const { insight } = useObjectContext();

	return (
		<Stack direction='row' alignItems='center' spacing={3} sx={{ mt: 0.5 }}>
			<HeaderDetail label='Income Invoiced' testId='client-gross-invoiced'>
				{formatCurrency({
					num: insight?.Income?.GrossInvoicedIncome ?? 0,
					showDecimal: true,
				})}
			</HeaderDetail>
			<HeaderDetail label='Received' testId='client-gross-received'>
				{formatCurrency({
					num: insight?.Income?.GrossPaidIncome ?? 0,
					showDecimal: true,
				})}
			</HeaderDetail>
		</Stack>
	);
};
